import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useState, useEffect } from 'react'
import Modal from 'react-modal';
import { isEmpty } from 'underscore';
import UserService from '../../../services/UserService';


const User: FC<any> = observer(data => {
    const { user, index } = data;
    const [organizations, setOrganizations] = useState<[]>([]);
    const [orgTitle, setOrgTitle] = useState<string[]>([]);
    const [specializations, setSpecializations] = useState<[]>([]);
    const [specTitle, setSpecTitle] = useState<string[]>([]);

    const getOrganizations = async () => {
        const res = await UserService.getOrganizations('');
        setOrganizations(res.data.results);
    };

    const getSpecializations = async () => {
        const res = await UserService.getSpecializations('');
        setSpecializations(res.data.results);
    };

    useEffect(() => {
        getOrganizations();
        getSpecializations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isEmpty(organizations)) {
            setOrgTitle([]);
            // eslint-disable-next-line array-callback-return
            organizations.map(item => {
                // eslint-disable-next-line array-callback-return
                user['organizations'].map((sid: any) => {
                    if (item['id'] === sid) {
                        setOrgTitle(orgTitle => [...orgTitle, item['organization']]);
                    }
                });
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizations]);

    useEffect(() => {
        if (!isEmpty(specializations)) {
            setSpecTitle([]);
            // eslint-disable-next-line array-callback-return
            specializations.map(item => {
                // eslint-disable-next-line array-callback-return
                user['specializations'].map((sid: any) => {
                    if (item['id'] === sid) {
                        setSpecTitle(specTitle => [...specTitle, item['specialization']]);
                    }
                });
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [specializations]);

    
    return (
            <tr>
                <th scope="row">{index + 1}</th>
                <td>{user['fio']}</td>
                <td>{user['municipality']}</td>
                <td>{orgTitle.join(', ')}</td>
                <td>{specTitle.join(', ')}</td>
                <td>{user['phone']}</td>
            </tr>
    )
});


interface ModalProps {
    toggle: boolean;
    setToggle: (value: boolean) => void;
}

export const SpecInfoFullModal: FC<ModalProps> = observer(props => {
    const { toggle, setToggle } = props;
    const [users, setUsers] = useState([]);
    const [fix, setFix] = useState(true);

    const getSIF = async () => {
        const qa = await UserService.getSpecInfoFull();
        setUsers(qa.data.results);
    };

    useEffect(() => {
        getSIF();
        setFix(false);
    }, [fix, toggle]);

    const onRequestClose = () => {
        setToggle(false);
    };

    const getUsers = () => users.map((user: any, index: number) => {
        return <User key={user['id']} {...{ user, index }} />
    })

    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} className='Modal'>
            <div className="row Modal__Head d-flex">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <span className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                </div>
            </div>
            <form className="Modal__Body">
                <div className="form-group mb-3">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col-md-1">№</th>
                                <th scope="col-md-3">ФИО</th>
                                <th scope="col-md-3">Муниципалитет</th>
                                <th scope="col-md-3">Организация</th>
                                <th scope="col-md-1">Специальность</th>
                                <th scope="col-md-1">Телефон</th>
                            </tr>
                        </thead>
                        <tbody>
                            {getUsers()}
                        </tbody>
                    </table>

                </div>
            </form>
        </Modal >
    );
});